import { render } from "./PersonalProfile.vue?vue&type=template&id=c0d16a72"
import script from "./PersonalProfile.vue?vue&type=script&lang=js"
export * from "./PersonalProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__